// extracted by mini-css-extract-plugin
export default {"companyContainer":"KL-z","companyImage":"LL-z","container":"ML-z","heading":"NL-z","darkText":"OL-z","smallHeading":"PL-z","darkBackground":"QL-z","whiteBackground":"RL-z"};